import axios from "axios";
import { shouldBlockRequest } from "@/helpers/handlers/demoService";
import { APP_DEMO } from "@/config/demo";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";

import { store } from "@/store/store";
import { i18n } from "@/main";
import { fromPairs } from "lodash";

export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

const CancelToken = axios.CancelToken;

axiosInstance.interceptors.request.use(config => {
  // if demo version, we cancel the request and show demo modal
  if (shouldBlockRequest(config)) {
    return {
      ...config,
      cancelToken: new CancelToken(cancel =>
        cancel(APP_DEMO.REQUEST_CANCEL_MSG)
      )
    };
  }

  const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER));
  const companyId =
    store.getters["company/companyId"] || store.state.company.id;
  const selectedLocale = store.getters["settings/selectedLocale"];

  if (user && user.token) {
    config.headers.common["Authorization"] = `Token ${user.token}`;
  } else {
    delete config.headers.common["Authorization"];
  }

  if (companyId) {
    config.headers.common["Company-Id"] = companyId;
  } else {
    delete config.headers.common["Company-Id"];
  }

  if (selectedLocale) {
    config.headers.common["Accept-Language"] = selectedLocale;
  } else {
    config.headers.common["Accept-Language"] = i18n.fallbackLocale; // by default: en-US
  }

  return config;
});

export const apiService = axiosInstance;
